import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SelectInput from "../../../general/SelectInput";
import { EditableProps } from "../../editableProps";
import { updateNodeProperty } from "../../../../store/slices/BuilderSlice/builderSlice";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { DividerNode } from "@common/build/types";
import { PATTERN_OPTIONS, DEFAULT_PATTERN } from "@common/components/BuilderDivider/patterns/DividerPatterns";
import "./styles.scss";

const PatternStyle: React.FC<EditableProps> = ({ title }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as DividerNode;

    if (!node) return null;
    const pattern = node.pattern || DEFAULT_PATTERN;    
    const patternOptions = PATTERN_OPTIONS;
       
    const onPatternSelectCallback = (value: string) => {
        
            dispatch(
                updateNodeProperty({
                    propertyPath: ["pattern"],
                    value
                })
            );
    };

    return (
            <SelectInput 
                title={title || "Type"} 
                value={pattern} 
                options={patternOptions} 
                callback={onPatternSelectCallback}
                className="pattern-style-select"
            />
    );
};

export default PatternStyle; 


